/* ==================================================
   #25 — EXTERNAL LINKS
   Purpose: Open external HTTP and HTTPS links
   in a new browser tab.
   Added: 2026-07-28
   ================================================== */

function prepareExternalLinks(container = document) {
  const links = container.querySelectorAll('a[href]');

  links.forEach((link) => {
    let url;

    try {
      url = new URL(link.href, window.location.href);
    } catch {
      return;
    }

    const isExternal =
      ['http:', 'https:'].includes(url.protocol) &&
      url.hostname !== window.location.hostname;

    if (!isExternal) {
      return;
    }

    link.target = '_blank';

    const relValues = new Set(
      (link.getAttribute('rel') || '').split(/\s+/).filter(Boolean)
    );

    relValues.add('noopener');
    relValues.add('noreferrer');

    link.setAttribute('rel', [...relValues].join(' '));
  });
}

document.addEventListener('DOMContentLoaded', () => {
  prepareExternalLinks();
});

document.addEventListener('shopify:section:load', (event) => {
  prepareExternalLinks(event.target);
});

/* ==================================================
   #31 — GLOBAL TRANSPARENT HEADER
   Purpose: Enable Impact's native transparent header
   behavior on all storefront pages.
   Added: 2026-07-28
   ================================================== */

function enableGlobalTransparentHeader() {
  const firstSection = document.querySelector(
    '[role="main"] > .shopify-section:first-child'
  );

  const header = document.querySelector('store-header.header');

  if (!firstSection || !header || !firstSection.firstElementChild) {
    return;
  }

  firstSection.firstElementChild.setAttribute(
    'allow-transparent-header',
    ''
  );

  if (typeof header._setupTransparentHeader === 'function') {
    header._setupTransparentHeader();
  }
}

if (document.readyState === 'loading') {
  document.addEventListener(
    'DOMContentLoaded',
    enableGlobalTransparentHeader,
    { once: true }
  );
} else {
  enableGlobalTransparentHeader();
}

document.addEventListener(
  'shopify:section:load',
  enableGlobalTransparentHeader
);

/* ==================================================
   #41 — COPY CODE MESSAGE
   Purpose: Copy promo codes and temporarily display
   the COPIED confirmation message.
   Added: 2026-07-30
   ================================================== */

window.copyAndShowMessage = async function (element) {
  if (!element) {
    return;
  }

  const originalText = element.textContent.trim();

  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(originalText);
    } else {
      const input = document.createElement('input');

      input.value = originalText;
      input.setAttribute('readonly', '');
      input.style.position = 'fixed';
      input.style.opacity = '0';

      document.body.appendChild(input);
      input.select();

      document.execCommand('copy');
      input.remove();
    }

    element.textContent = 'COPIED';

    window.setTimeout(() => {
      element.textContent = originalText;
    }, 2000);
  } catch (error) {
    console.error('Unable to copy code:', error);
  }
};
